var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"vr-product-card",attrs:{"to":{name: _vm.product.pathName}}},[_c('div',{class:{
      'vr-product-card__container': true,
      'vr-product-card__container--dark': _vm.dark,
    },style:(_vm.coverUrl)},[_c('h5',{staticClass:"vr-product-card__container__title"},[_vm._v(" "+_vm._s(_vm.product.name)+" ")]),_c('p',{staticClass:"vr-product-card__container__text"},[_vm._v(" "+_vm._s(_vm.product.text)+" ")]),_c('span',{staticClass:"vr-product-card__container__span"},[_vm._v(" Узнать больше "),_c('chevron-down')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }